import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    justify-content: flex-end;
    &>button {
        margin-left: 10px;
        
        svg {
            margin: 0;
        }
    }
    &>button:first-child {
        margin-left: 0;
    }
`